// 02.1 · Recuperar contraseña (un campo) y 02.2 · Enlace enviado.
// Siempre responder éxito (no revelar si el correo existe). Reenvío con
// cuenta regresiva de 60s. Callable real: resetPassword() (Resend).
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { resetPassword } from '../../../auth/authHelpers';
import { I } from '../ui';

export function RecuperarPaso1() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [touched, setTouched] = useState(false);
  const [loading, setLoading] = useState(false);
  const err = !/^\S+@\S+\.\S+$/.test(email.trim()) ? 'Revisa el formato del correo.' : '';

  const enviar = async () => {
    setTouched(true);
    if (err || loading) return;
    setLoading(true);
    const clean = email.trim().toLowerCase();
    try { await resetPassword(clean); } catch (_e) { /* siempre éxito: no revelar existencia */ }
    navigate('/app/recuperar/enviado', { replace: true, state: { email: clean } });
  };

  return (
    <div className="v3"><div className="lg-wrap">
      <div className="nav" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <button type="button" className="back" aria-label="Volver" onClick={() => navigate('/app')}><I.back /></button>
      </div>
      <h1 className="lg-h">Recupera tu contraseña</h1>
      <p className="lg-p">Te enviaremos un enlace para crear una nueva. Vale por 30 minutos.</p>
      <div className="fields" style={{ marginTop: 26 }}>
        <div className={`fld${touched && err ? ' err' : ''}`}><p className="l">Correo</p><div className="row2">
          <input type="email" inputMode="email" autoComplete="email" autoFocus value={email} placeholder="tu@email.com"
            onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && enviar()} /></div></div>
        {touched && err && <p className="fld-err">{err}</p>}
      </div>
      <button type="button" className="cta" style={{ marginTop: 18 }} onClick={enviar} disabled={loading}>
        {loading ? 'Enviando…' : 'Enviar enlace'}<I.arrow />
      </button>
      <p className="lg-foot">¿Recordaste la contraseña? <strong onClick={() => navigate('/app')}>Ingresar</strong></p>
    </div></div>
  );
}

export function RecuperarEnviado() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const email = state?.email || '';
  const [left, setLeft] = useState(60);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (left <= 0) return undefined;
    const t = setTimeout(() => setLeft((v) => v - 1), 1000);
    return () => clearTimeout(t);
  }, [left]);

  const reenviar = async () => {
    if (left > 0 || sending || !email) return;
    setSending(true);
    try { await resetPassword(email); } catch (_e) { /* siempre éxito */ }
    setSending(false); setLeft(60);
  };
  const mm = `${Math.floor(left / 60)}:${String(left % 60).padStart(2, '0')}`;

  return (
    <div className="v3"><div className="lg-wrap">
      <div className="nav" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <button type="button" className="back" aria-label="Volver" onClick={() => navigate('/app/recuperar')}><I.back /></button>
      </div>
      <div className="ok-box">
        <div className="ic"><I.mail /></div>
        <h1 className="lg-h" style={{ marginTop: 20 }}>Revisa tu correo</h1>
        <p className="lg-p">Enviamos un enlace a <b style={{ color: 'var(--ink)' }}>{email || 'tu correo'}</b>. Si no aparece, mira en spam.</p>
      </div>
      <a className="cta" style={{ marginTop: 28 }} href="mailto:">Abrir app de correo</a>
      <button type="button" className="cta ghost sm" style={{ marginTop: 9 }} onClick={reenviar} disabled={left > 0 || sending}>
        {left > 0 ? `Reenviar en ${mm}` : sending ? 'Reenviando…' : 'Reenviar enlace'}
      </button>
      <p className="lg-foot">¿Correo equivocado? <strong onClick={() => navigate('/app/recuperar')}>Cambiar</strong></p>
    </div></div>
  );
}
